import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { GeneralListResolved } from './general.list.interfaces';
import { TypeService } from '../general.service';


@Injectable()
export class GeneralListResolver  {

    constructor(private types: TypeService) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<GeneralListResolved> {
        let docType = route.paramMap.get('type');
        if (!docType && route.data) {
          docType = route.data.type;
        }

        const info = this.types.infos.find(itm => itm.type === docType);
        return of(info.resolvedList());
    }
}
